<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <b-card>
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-cubes mr-2" />Daftar Rekomendasi
                    Dashboard
                </h5>
                <hr />
                <b-table
                    bordered
                    hover
                    show-empty
                    :busy="isBusy"
                    :items="recommendedItems"
                    :fields="recommendedFields"
                    responsive
                    class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada data tipe rekomendasi.
                    </template>
                    <template v-slot:cell(type_name)="row">
                        {{ row.item.type_name }}
                    </template>
                    <template v-slot:cell(name)="row">
                        {{ row.item.name }}
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button
                                size="sm"
                                variant="warning"
                                :disabled="isBusy || isSubmitting"
                                v-b-tooltip.hover.top
                                title="Ubah"
                                @click="prepareEdit(row.item)"
                            >
                                <i class="fa fa-fw fa-pencil" />
                            </b-button>
                            <b-button
                                size="sm"
                                class="ml-2"
                                variant="danger"
                                :disabled="isBusy || isSubmitting"
                                v-b-tooltip.hover.top
                                title="Hapus"
                                @click="confirmDelete(row.item)"
                            >
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </b-card>
            <b-card>
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-cubes mr-2" />Daftar Semua Tipe Barang
                </h5>
                <hr />
                <b-row>
                    <b-col md="3">
                        <b-form-group label="Nama Tipe Barang">
                            <b-form-input
                                v-model="filter.name"
                                maxlength="50"
                                @keydown.enter="getItems"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Aksi">
                            <b-button
                                variant="primary"
                                :disabled="isBusy || isSubmitting"
                                @click="getItems()"
                            >
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-table
                    bordered
                    hover
                    show-empty
                    no-local-sorting
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive
                    class="mb-3"
                    @sort-changed="onSortChanged"
                >
                    <template v-slot:empty>
                        Tidak ada data tipe barang.
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button
                            size="sm"
                            variant="warning"
                            v-b-tooltip.hover.top
                            :disabled="
                                row.item.total_items <= 0 ||
                                isBusy ||
                                isSubmitting
                            "
                            :title="
                                row.item.total_items > 0
                                    ? 'Rekomendasikan'
                                    : 'Jumlah Unit tidak memadai'
                            "
                            @click="prepareCreate(row.item)"
                        >
                            <i class="fa fa-fw fa-window-maximize" />
                        </b-button>
                    </template>
                </b-table>
                <PageSizer
                    :totalRows="totalRows"
                    :page="currentPage"
                    :options="options"
                    @limit-change="onLimitChange"
                    @page-change="onPageChange"
                />
            </b-card>
        </div>
        <b-modal
            id="m-create"
            :title="'Rekomendasikan ' + input.title"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-img-lazy
                v-if="$helper.isBlank(input.image_path)"
                class="preview-image"
                src="/img/img-preview.png"
            ></b-img-lazy>
            <b-img-lazy
                v-else
                class="preview-image"
                :src="input.image_path"
            ></b-img-lazy>
            <div
                v-if="$helper.isBlank(input.image)"
                class="d-block invalid-feedback"
            >
                Mohon upload gambar.
            </div>
            <b-button
                variant="primary"
                class="mt-3 mb-3"
                :disabled="isSubmitting"
                @click="$refs.fileuploadinput.click()"
            >
                Ubah Gambar
            </b-button>
            <b-form-group
                label="Judul Rekomendasi"
                :state="inputNameState"
                invalid-feedback="Judul rekomendasi minimal 4 karakter."
            >
                <b-form-input
                    v-model="input.name"
                    :state="inputNameState"
                    maxlength="100"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="
                        !(inputImageState && inputNameState) || isSubmitting
                    "
                    @click="confirmCreate"
                >
                    {{ isSubmitting ? "Membuat..." : "Buat Rekomendasi" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-edit"
            :title="'Ubah Rekomendasi ' + edit.name"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-img-lazy
                class="preview-image mb-3"
                :src="edit.image_path"
            ></b-img-lazy>
            <b-button
                variant="primary"
                class="mb-3"
                :disabled="isSubmitting"
                @click="$refs.fileuploadedit.click()"
            >
                Ubah Gambar
            </b-button>
            <b-form-group
                label="Judul Rekomendasi"
                :state="editNameState"
                invalid-feedback="Judul rekomendasi minimal 4 karakter."
            >
                <b-form-input
                    v-model="edit.name"
                    :state="editNameState"
                    maxlength="100"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="!editNameState || isSubmitting"
                    @click="confirmEdit"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan Perubahan" }}
                </b-button>
            </div>
        </b-modal>
        <input
            style="opacity: 0; filter: alpha(opacity=0)"
            ref="fileuploadinput"
            type="file"
            @change="onFileChangeInput"
            accept="image/png, image/jpeg"
        />
        <input
            style="opacity: 0; filter: alpha(opacity=0)"
            ref="fileuploadedit"
            type="file"
            @change="onFileChangeEdit"
            accept="image/png, image/jpeg"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            filter: {
                name: "",
            },

            input: {
                type_id: "",
                title: "",
                name: "",
                image_path: "",
                image: null,
            },

            edit: {
                id: "",
                name: "",
                image_path: "",
                image: null,
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                { key: "brand", label: "Brand", sortable: true },
                { key: "name", label: "Nama Tipe Barang", sortable: true },
                { key: "item_kind", label: "Jenis Barang", sortable: true },
                { key: "total_items", label: "Jumlah Unit", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            recommendedFields: [
                { key: "type_name", label: "Nama Tipe Barang", sortable: true },
                {
                    key: "name",
                    label: "Judul Rekomendasi",
                    sortable: true,
                },
                { key: "action", label: "Aksi", sortable: false },
            ],

            recommendedItems: [],
            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortKey: "type_name",
            sortDescending: false,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getRecommendedItems = this.getRecommendedItems();

            let getItems = this.getItems();

            Promise.all([getRecommendedItems, getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        prepareCreate(item) {
            this.input.title = item.brand + " - " + item.name;
            this.input.type_id = item.id;
            this.input.name = "";
            this.input.image_path = "";
            this.input.image = null;
            this.$refs.fileuploadinput.value = null;
            this.$bvModal.show("m-create");
        },

        confirmCreate() {
            let data = new FormData();

            data.append("id", this.input.type_id);
            data.append("name", this.input.name);
            data.append("file", this.input.image);

            this.isSubmitting = true;

            this.$axios
                .post("admin/rekomendasiItemTypes", data)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Rekomendasi baru berhasil dibuat!"
                    );
                    this.$bvModal.hide("m-create");
                    this.init();
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareEdit(item) {
            this.edit.id = item.id;
            this.edit.name = item.name;
            this.edit.image_path = this.$BASE_FILE_PATH + item.image;
            this.edit.image = null;
            this.$refs.fileuploadedit.value = null;
            this.$bvModal.show("m-edit");
        },

        confirmEdit() {
            let data = new FormData();

            data.append("name", this.edit.name);
            if (!this.$helper.isBlank(this.edit.image)) {
                data.append("file", this.edit.image);
            }

            this.isSubmitting = true;

            this.$axios
                .post("admin/updateRekomendasiItemTypes/" + this.edit.id, data)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Data rekomendasi berhasil diubah!"
                    );
                    this.$bvModal.hide("m-edit");
                    this.getRecommendedItems();
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmDelete(item) {
            let isConfirmed = confirm(
                "Apakah anda yakin ingin menghapus Rekomendasi " +
                    item.name +
                    " ini? Rekomendasi tidak akan ditampilkan lagi di Dashboard E-commerce!"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            this.$axios
                .delete("admin/rekomendasiItemTypes/" + item.id)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Rekomendasi tipe barang berhasil dihapus!"
                    );
                    this.getRecommendedItems();
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name;
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }
            return this.$axios
                .get("admin/getItemTypes" + param)
                .then((res) => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    sessionStorage.setItem(
                        "listTypeFilter",
                        JSON.stringify(this.filter)
                    );
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getRecommendedItems() {
            this.isBusy = true;
            this.recommendedItems = [];

            return this.$axios
                .get("admin/getRekomendasiItemTypes")
                .then((res) => {
                    this.recommendedItems = res.data.data;
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        onFileChangeInput(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            else if (files[0].size > this.$uploadLimit) {
                this.$helper.toastError(
                    this,
                    "Ukuran gambar tidak boleh melebihi 5MB!"
                );
                return;
            }
            this.input.image = files[0];
            this.input.image_path = URL.createObjectURL(files[0]);
        },
        onFileChangeEdit(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            else if (files[0].size > this.$uploadLimit) {
                this.$helper.toastError(
                    this,
                    "Ukuran gambar tidak boleh melebihi 5MB!"
                );
                return;
            }
            this.edit.image = files[0];
            this.edit.image_path = URL.createObjectURL(files[0]);
        },
    },

    computed: {
        inputImageState() {
            if (this.$helper.isBlank(this.input.image)) {
                return false;
            }
            return true;
        },
        inputNameState() {
            if (this.input.name.length <= 0) return null;
            return this.input.name.length >= 4;
        },
        editNameState() {
            if (this.edit.name.length <= 0) return null;
            return this.edit.name.length >= 4;
        },
    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listTypeFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listTypeFilter"));
        }
        this.init();
    },
};
</script>

<style scoped>
.preview-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    aspect-ratio: 1 / 1;
    max-height: 450px;
}
</style>
